export default "/_next/static/assets/images/sporttip/sporttip-slogan.54f2df597b7862ab13a872b7bce99b31.svg";